<div class='task-types-main' data-cy="task-type-container">
  <mat-progress-spinner *ngIf="tableModel === undefined" style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)" diameter="100" mode="indeterminate" data-cy="task-type-loading-spinner"></mat-progress-spinner>
  <mat-grid-list *ngIf="tableModel !== undefined" cols="6" rowHeight="100%" style="height:100%;" data-cy="task-type-grid">
    <mat-grid-tile colspan="2" data-cy="task-type-list-tile">
      <mat-card appearance="outlined" style="width:100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="task-type-list-card">
        <span class="configuration-section-title" data-cy="task-type-list-title">Task Types</span>
        <div style="flex: 1; max-height: 100%; overflow-y: hidden;" data-cy="task-type-list-content">

          <mat-form-field style="width:100%; margin-top: 3px;" data-cy="task-type-client-field">
            <mat-label data-cy="task-type-client-label">Practice (Licensee)</mat-label>
            <mat-select [value]="selectedClient" (selectionChange)="onChangeClient($event.value)" data-cy="task-type-client-select">
              <mat-option *ngFor="let client of clientList; let i = index" [value]="client" data-cy="task-type-client-option-{{i}}">
                {{client.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="width:100%" data-cy="task-type-location-field">
            <mat-label data-cy="task-type-location-label">Practice Locations</mat-label>
            <mat-select [(value)]="selectedLocation" (selectionChange)="onChangeLoc($event.value)" data-cy="task-type-location-select">
              <mat-option *ngFor="let loc of locationList; let i = index" [value]="loc" data-cy="task-type-location-option-{{i}}">
                {{loc.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <app-tdo-table #taskTypeTable [sortActive]="true" [isSearchable]="false" *ngIf="tableModel !== undefined" [tdoTableModel]="tableModel" (actionClick)="onTdoTableItemActionClick($event)" (itemSelected)="onTdoTableItemClick($event)" data-cy="task-type-table"></app-tdo-table>
        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile colspan="4" data-cy="task-type-detail-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="task-type-detail-card">
        <mat-card-content data-cy="task-type-detail-content">
          <div style="max-width: 700px;" data-cy="task-type-detail-container">
            <span class="configuration-section-title" data-cy="task-type-detail-title">Task Type Information</span>
            <app-tdo-configuration-action-bar
              #actionBar
              *ngIf="(this.locationList.length > 0)"
              [showEdit]="(!isEditing && this.taskTypeList.length > 0)"
              (editClick)="onEdit($event)"
              [saveDisabled]="saveDisabled"
              [showSave]="!saveDisabled"
              [showCancel]="!saveDisabled"
              (saveClick)="onSave($event)"
              (cancelClick)="onCancel($event)"
              (newClick)="onNew($event)"
              [showAdd]="false"
              [newHidden]="false"
              data-cy="task-type-action-bar">
            </app-tdo-configuration-action-bar>

            <div *ngIf="this.selectedTaskType" data-cy="task-type-form">

              <!--                                    [dataSource]="taskTypeEnums"-->
              <app-validvalueselect style="width:100%"
                                    [disabled]="!this.isEditing"
                                    validvaluename ="enumUserTaskType"
                                    vvplaceholder="Task Type"
                                    [(selectedValue)]="selectedTaskType.enumUserTaskTypeID" (selectedValueChange)="configurationService.setDirty();"
                                    data-cy="task-type-select"></app-validvalueselect>

              <!--                                    [dataSource]="taskTimeCalculationEnums"-->
              <app-validvalueselect style="width:100%"
                                    [disabled]="!this.isEditing"
                                    validvaluename ="enumTaskTimeCalculation"
                                    vvplaceholder="Task Time Calculation"
                                    [(selectedValue)]="selectedTaskType.enumTaskTimeCalculationID" (selectedValueChange)="configurationService.setDirty();"
                                    data-cy="task-type-time-calculation-select"></app-validvalueselect>

              <div style="display: flex;" data-cy="task-type-time-container">
                <div style="flex-basis: 100px" *ngIf="selectedTaskType.enumTaskTimeCalculationID" data-cy="task-type-time-input-container">
                  <app-tdo-input
                    *ngIf="selectedTaskType.enumTaskTimeCalculationID === enumTaskTimeCalculationIDDelay"
                    style="width:100%"
                    [(ngModel)]="this.selectedTaskType.DelayTimeInDays"
                    placeholder="Days"
                    (change)="configurationService.setDirty();"
                    [disabled]="!this.isEditing"
                    data-cy="task-type-delay-days-input">
                  </app-tdo-input>

                  <app-tdo-input
                    *ngIf="selectedTaskType.enumTaskTimeCalculationID === enumTaskTimeCalculationIDLead"
                    style="width:100%"
                    [(ngModel)]="this.selectedTaskType.LeadTimeInDays"
                    placeholder="Days"
                    (change)="configurationService.setDirty();"
                    [disabled]="!this.isEditing"
                    data-cy="task-type-lead-days-input">
                  </app-tdo-input>
                </div>
                <div style="flex:1" data-cy="task-type-manual-container">
                  <mat-checkbox class="example-margin"
                                [(ngModel)]="selectedTaskType.isManual"
                                [color]="'primary'"
                                (change)="configurationService.setDirty();"
                                [disabled]="!this.isEditing"
                                data-cy="task-type-manual-checkbox">
                    Manual
                  </mat-checkbox>
                </div>
              </div>

              <span class="configuration-section-title" data-cy="task-type-destinations-title">Destinations</span>

              <app-tdo-table #taskTypeDestinationsTable [sortActive]="true" [isSearchable]="false" *ngIf="tableModelDestinations !== undefined" [tdoTableModel]="tableModelDestinations" (actionClick)="onTdoTableItemActionClickDestination($event)" (itemSelected)="onTdoTableDestinationItemClick($event)" data-cy="task-type-destinations-table"></app-tdo-table>

              <div style="display: flex; padding-top: 10px" data-cy="task-type-add-buttons-container">
                <div style="flex-basis: 100px" data-cy="task-type-add-user-container">
                  <button mat-button class="tdo-button tdo-save" (click)="addUser()" [disabled]="!isEditing" data-cy="task-type-add-user-button">Add User</button>
                </div>
                <div style="flex-basis: 150px" data-cy="task-type-add-group-container">
                  <button mat-button class="tdo-button tdo-save" (click)="addUserGroup()" [disabled]="!isEditing" data-cy="task-type-add-group-button">Add User Group</button>
                </div>
              </div>
            </div>
            <div *ngIf="this.isLoading" data-cy="task-type-detail-loading">
              <mat-spinner style="margin-left: auto; margin-right: auto;" data-cy="task-type-detail-spinner"></mat-spinner>
            </div>

          </div>

        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>

